export default "__VITE_ASSET__BuR78pgS__"